export * from './components';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';

import { ComponentId } from "@omegagrid/core";
import rp, { AppComponent, Application, Container, parseComponentId } from '@reporting/rp-app-host';
import { componentFactories } from './factories';

export class AdminApplication extends Application {

	async init(container: Container) {
		super.init(container);
		container.services.register('analytics');
		container.services.register('auth');
		container.services.register('accounting');
		container.services.register('etl');
		container.services.register('definition');
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		const parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		if (!factory) return null;
		return factory(this, parsedId);
	}
}
